import React from 'react'
import PropTypes from 'prop-types'
import * as Component from './Icon.styles'

const Icon = React.forwardRef((props, ref) => {
  const { className, isSpinning, icon, ...other } = props

  return (
    <>
      <Component.GlobalIconStyles />
      <Component.IconContainer
        ref={ ref }
        className={ className }
        isSpinning={ isSpinning }
        { ...other }>
        {icon}
      </Component.IconContainer>
    </>
  )
})

Icon.defaultProps = {
  isSpinning: false,
}

Icon.propTypes = {
  /** The CSS class name of the wrapper element. */
  className: PropTypes.string,
  /** If true, the icon is spinning */
  isSpinning: PropTypes.bool,
}

export default Icon
